var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.facebookAppId)?_c('div',{staticClass:"facebook-component-container",class:{ mastery: _vm.mastery },on:{"click":function($event){return _vm.authenticate()}}},[(_vm.mastery)?_c('icon',{attrs:{"name":'facebook'}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }